import React, {Component} from "react";
import _ from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {DataList} from 'primereact/components/datalist/DataList';

import * as actions from '../../actions/delegation';
import FormField from "../formField/FormField";
import validate from "validate.js";
import Popup from "../Popup";

class DelegateAuthorityPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            delegated: {},
            errors: {},
            showDelegatedPersonPopUp: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleRulesEnabled = this.handleRulesEnabled.bind(this);
        this.remove = this.remove.bind(this);
        this.resetError = this._resetError.bind(this);
    }

    componentWillMount() {
        this.props.actions.fetchDelegates();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({delegated: {firstName: '', lastName: '', impersonatorIdentityNumber: '', rulesEnabled: false}});
    }

    handleAddDelegate = (e) => {
        e.preventDefault();
        if (this._validateForm()) {
            const onComplete = ()=>this.onToggleDelegatedPopUp();
            this.props.actions.addDelegate(this.state.delegated,onComplete);

        }
    }

    remove(d) {
        this.props.actions.removeDelegate(d);
    }

    handleChange(event, attribute) {
        this.setState({delegated: _.extend({}, this.state.delegated, {[attribute]: _.trimStart(event.target.value)})})
    }

    handleRulesEnabled(attribute) {
        this.setState({delegated: _.extend({}, this.state.delegated, {[attribute]: !this.state.delegated.rulesEnabled})});
    }

    _resetError(attribute) {
        const {errors} = this.state;
        this.setState({errors: _.extend({}, errors, {[attribute]: null})})
    }

    _validateForm() {
        const {delegated} = this.state;
        const options = {fullMessages: false};

        const constraints = {
            firstName: {presence: true, length: {minimum: 1, message: 'required'}},
            lastName: {presence: true, length: {minimum: 1, message: 'required'}},
            impersonatorIdentityNumber: {presence: true, length: {minimum: 1, message: 'required'}},
        };
        const addressContraints = {
            street: {presence: true, length: {minimum: 1, message: 'required'}},
        };
        const errors = validate(delegated, constraints, options)

        this.setState({errors});
        return _.isEmpty(errors);
    }

    onToggleDelegatedPopUp = () => {
        this.setState(prevState => ({showDelegatedPersonPopUp: !prevState.showDelegatedPersonPopUp}))
    };
    _renderDelegatesTemplate(delegate) {
        return (
            <div className="row">
                <div className="col-md-3 col-sm-3 col-xs-3">
                    <label>{delegate.impersonatorIdentityNumber}</label>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-4">
                    <label>{delegate.firstName + ' ' + delegate.lastName}</label>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-4">
                    <label>{delegate.rulesEnabled ? " Yes" : " No"}</label>
                </div>

                <div className="col-md-1 col-sm-1 col-xs-1" style={{padding: 0}}>
                    <a
                        className="btn"
                        role="button"
                        id="remove-btn"
                        onClick={() => this.remove(delegate)}>
                        <i className="fa fa-times" aria-hidden="true"/>
                    </a>
                </div>
                <hr/>
            </div>
        );
    }
    _renderDelegateList() {
        const {delegatedList} = this.props;
        const hasDelegates = _.size(delegatedList) > 0;
        if (!hasDelegates) return null;
        return (
            <div>
                <br/>
                <div>
                    <div className="row">
                        <div className="col-md-3 col-sm-3 col-xs-3">
                            <b>ID Number</b>
                        </div>
                        <div className="col-md-4 col-sm-4 col-xs-4">
                            <b>Names</b>
                        </div>
                        <div className="col-md-4 col-sm-4 col-xs-4">
                            <b>Can Configure?</b>
                        </div>
                        <div className="col-md-1 col-sm-1 col-xs-1"/>
                    </div>
                    <DataList
                        className="ui-datalist-nobullets"
                        itemTemplate={this._renderDelegatesTemplate.bind(this)}
                        paginator={false}
                        rows={5}
                        value={delegatedList}
                    />
                </div>
            </div>
        )
    }

    _renderDelegatedPopUp() {
        const {loading} = this.props;
        const {delegated, errors, showDelegatedPersonPopUp} = this.state;
        if (!showDelegatedPersonPopUp) return null;
        return (
            <Popup onClose={this.onToggleDelegatedPopUp}>
                <div>
                    <div className="product-heading">
                        Delegate Information
                    </div>
                    <div className="title-gradient"/>
                </div>
                <br/>
                <DelegateDetailsCard
                    errors={errors}
                    delegated={delegated}
                    history={this.props.history}
                    loading={loading}
                    onChange={this.handleChange}
                    onResetError={this.resetError}
                    handleRulesEnabled={this.handleRulesEnabled}
                    onSubmit={this.handleAddDelegate}
                />
            </Popup>
        )
    }

    render() {
        const {loading} = this.props;
        if (loading) return null;
        return (
            <div className="page-container" onSubmit={this.handleSubmit}>
                <div className="page-main-section">
                    <div className="card-container-form">
                        <div className="section-title">
                            <span>Delegated Persons</span>
                        </div>

                        {this._renderDelegateList()}

                        <a className="flat-button-primary-light"
                            onClick={this.onToggleDelegatedPopUp}
                        >Add Delegate</a>

                    </div>
                </div>
                {this._renderDelegatedPopUp()}
            </div>
        );
    }
}

class DelegateDetailsCard extends Component {
    _renderFooter() {
        const {onSubmit} = this.props;
        return (
            <div className="action-button-container" style={{width: "100%"}}>
                <div/>
                <button
                    className="action-btn-secondary"
                    onClick={onSubmit}
                    type="button"
                >Add
                </button>
            </div>
        )
    }

    render() {
        const {errors, delegated, handleRulesEnabled, onChange, onResetError} = this.props;

        return (
            <div className="flexColumn">
                <div className="popup-content">
                    <div className="flexColumn">
                        <div className="card-container-form">
                            <FormField className={"form-group"} id="od"
                                       error={errors && errors.impersonatorIdentityNumber}>
                                <label htmlFor="impersonatorIdentityNumber">ID Number</label>
                                <input
                                    className="form-control"
                                    name="impersonatorIdentityNumber"
                                    onChange={(event) => {
                                        errors && errors.impersonatorIdentityNumber && onResetError('impersonatorIdentityNumber');
                                        onChange(event, 'impersonatorIdentityNumber')
                                    }}
                                    type="text"
                                    value={delegated && delegated.impersonatorIdentityNumber}
                                />
                            </FormField>

                            <FormField className={"form-group"} id="firstName" error={errors && errors.firstName}>
                                <label htmlFor="tradingAs">Name</label>
                                <input
                                    className="form-control"
                                    name="firstName"
                                    value={delegated && delegated.firstName}
                                    onChange={(event) => {
                                        errors && errors.firstName && onResetError('firstName');
                                        onChange(event, 'firstName')
                                    }}
                                    type="text"
                                />
                            </FormField>

                            <FormField className={"form-group"} id="lastName" error={errors && errors.lastName}>
                                <label htmlFor="lastName">Surname</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="lastName"
                                    value={delegated && delegated.lastName}
                                    onChange={(event) => {
                                        errors && errors.lastName && onResetError('lastName');
                                        onChange(event, 'lastName')
                                    }}
                                />
                            </FormField>
                            <div>
                                <label
                                    className="checkbox-inline"
                                    onClick={() => handleRulesEnabled('rulesEnabled')}>
                                    <i
                                        className={delegated && delegated.rulesEnabled ? "fa fa-check-square-o" : "fa fa-square-o"}
                                        style={{color: "rgb(0, 51, 170)", fontSize: 18, marginRight: 10}}
                                    />Can Configure Rules?
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                {this._renderFooter()}
            </div>
        );
    }
}

function mapStateToProps({delegatedList, loading}, ownProps) {
    return {
        delegatedList: delegatedList && delegatedList.delegatedList ? delegatedList.delegatedList : [],
        loading,
    };
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(DelegateAuthorityPage);
